<nb-select
    required
    [selected]="selectedOption$ | async"
    (selectedChange)="valueChanged($event)"
    class="ms-4"
>
    @for (option of options$ | async; track option.id) {
        <nb-option [value]="option">
            @if (option.is_monosite) {
                {{ option.name }}
            } @else {
                {{ "The whole site" | translate }}
            }
        </nb-option>
    }
</nb-select>